// extracted by mini-css-extract-plugin
export var border = "_1k-7";
export var brand = "_1k-s";
export var button = "_1k-k";
export var center = "_1k-9";
export var centered = "_1k-5";
export var closeButton = "_1k-b";
export var disabledWrapper = "_1k-l";
export var error = "_1k-o";
export var extraLarge = "_1k-4";
export var extraSmall = "_1k-1";
export var fill = "_1k-h";
export var footer = "_1k-g";
export var footerAction = "_1k-i";
export var footerButtons = "_1k-j";
export var header = "_1k-6";
export var headerWithClose = "_1k-c";
export var icon = "_1k-n";
export var info = "_1k-r";
export var inline = "_1k-8";
export var large = "_1k-3";
export var main = "_1k-d";
export var modal = "_1k-0";
export var neutral = "_1k-t";
export var noPadding = "_1k-f";
export var none = "_1k-u";
export var scrollable = "_1k-e";
export var small = "_1k-2";
export var success = "_1k-q";
export var tight = "_1k-m";
export var titleIcon = "_1k-a";
export var warn = "_1k-p";